import React, { useState } from "react";
import { CategoryProduct } from "../../../domain/entities/CategoryProduct";
import Modal from "../modal/Modal";
import ProductItemList from "./ProductItemList";
import BenefitComponents from "../benefitComponents/BenefitComponents";

const API_URL = process.env.REACT_APP_IMAGE_URL_WITHOUT_STORAGE || "";

interface CategoryProductItemProps {
    categoryProduct: CategoryProduct;
}

const CategoryProductItem: React.FC<CategoryProductItemProps> = ({categoryProduct}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    // Configure background images and component lists based on category
    let componentList;

     // Create the complete image URL
    let backgroundImages = `${API_URL}${categoryProduct.background_image}`;
    let bannerImageCategory = `${API_URL}${categoryProduct.banner_products}`;

    componentList = (
        <div className="flex flex-col gap-3 mt-5">
            {categoryProduct.products.map((item) => (
                <ProductItemList key={item.id} productItem={item} />
            ))}
        </div>
    );

    return (
        <div 
            className="relative w-full h-64 md:w-96 md:h-96 flex flex-col items-center justify-center rounded-2xl overflow-hidden shadow-md"
            style={{ backgroundImage: `url(${backgroundImages})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
            
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/60" />
            
            {/* Content Container */}
            <div className="relative h-full flex flex-col items-center justify-center p-6">
                {/* Text Content */}
                <div className="text-center text-white"> {/* Added mb-10 to give space for button */}
                    <h2 className="text-xl md:text-2xl font-medium mb-1 font-poppins">
                        {categoryProduct.category}
                    </h2>
                    <p className="text-sm font-light font-poppins">
                        {categoryProduct.short_description}
                    </p>
                </div>

                {/* Button Container - Positioned at bottom center */}
                <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
                    <button
                        className="bg-[#9b284c] text-white text-xs rounded-lg px-2.5 py-1.5 md:px-4 md:py-2 font-bold hover:bg-[#801d3e] transition-all flex items-center gap-1 font-poppins"
                        onClick={openModal}
                    >
                        Selengkapnya
                    </button>
                </div>
            </div>

            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="p-4 md:p-8">
                    <h2 className="text-2xl font-bold text-black mb-4 text-start font-poppins">
                        {categoryProduct.category}
                    </h2>
                    <p className="text-sm text-gray-600 mb-8 md:mx-4 text-justify font-poppins">
                        {categoryProduct.long_description}
                    </p>
                    
                    {componentList}
                    
                    <h2 className="text-2xl font-bold mt-12 mb-6 md:mx-8 text-start font-poppins">
                        Keunggulan
                    </h2>
                    
                    {/* Benefits grid */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-4 mx-4 md:mx-10">
                        {categoryProduct.benefits.map((itemBenefit) => (
                            <div key={itemBenefit.description} className="flex flex-col items-center justify-center p-2 border border-gray-200 rounded-3xl bg-white shadow-sm h-40">
                                <BenefitComponents 
                                    imageUrl={itemBenefit.icon_url} 
                                    title={itemBenefit.description}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                {/* Background image */}
                <div className="mt-4 flex justify-center">
                    <img 
                        src={bannerImageCategory} 
                        alt="background product" 
                        className="w-full max-w-4xl h-auto object-cover"
                    />
                </div>
            </Modal>
        </div>
    );
};

export default CategoryProductItem;